export default "__VITE_ASSET__0a4413db__"